import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronUpThin = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M14.9603705,11.9276343 L7,3.96726376 L7.96726376,3 L16.8552686,11.8880048 L16.8156391,11.9276343 L16.8552686,11.9672638 L7.96726376,20.8552686 L7,19.8880048 L14.9603705,11.9276343 Z"
            transform="translate(11.927634, 11.927634) rotate(-90.000000) translate(-11.927634, -11.927634) "
        ></path>
    </StarryUIIcon>
);
